import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { POSTS } from "../blogData";
import SEO from "../components/SEO";
import Nav from "../components/Nav";
import Footer from "../components/Footer";

export default function BlogPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  const blogSchema = {
    "@context": "https://schema.org",
    "@type": "Blog",
    "@id": "https://ovarddigital.com/blog#webpage",
    "url": "https://ovarddigital.com/blog",
    "name": "OVARD Digital Insights — Digital Marketing Blog",
    "description": "Practical perspectives on branding, marketing strategy and digital growth from OVARD Digital — a digital marketing agency in Mysore, India.",
    "publisher": { "@id": "https://ovarddigital.com/#organization" },
    "isPartOf": { "@id": "https://ovarddigital.com/#website" },
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://ovarddigital.com/" },
        { "@type": "ListItem", "position": 2, "name": "Insights", "item": "https://ovarddigital.com/blog" }
      ]
    }
  };

  return (
    <div className="blog-page">
      <SEO
        title="Insights — Digital Marketing Blog"
        description="Practical perspectives on branding, digital marketing strategy and business growth from OVARD Digital — a full-service digital marketing agency in Mysore, India."
        canonical="/blog"
        schema={blogSchema}
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Insights", path: "/blog" }
        ]}
      />
      <Nav />

      {/* Hero */}
      <section className="blog-hero">
        <div className="blog-hero-grain" aria-hidden="true" />
        <div className="container blog-hero-inner">
          <span className="blog-hero-eyebrow">
            <span className="blog-hero-dot" />
            OVARD DIGITAL — INSIGHTS
          </span>
          <h1 className="blog-hero-h1">
            Thinking about<br />
            <span className="blog-hero-gold">brand, digital</span><br />
            and growth.
          </h1>
          <p className="blog-hero-sub">
            Practical perspectives on branding, marketing strategy and digital growth for businesses building something worth noticing.
          </p>
        </div>
      </section>

      {/* Posts grid */}
      <section className="blog-grid-section">
        <div className="container">
          <div className="blog-grid">
            {POSTS.map((post, i) => (
              <Link to={`/blog/${post.id}`} className="blog-card" key={post.id}>
                <div className="blog-card-img-wrap">
                  <img src={post.hero} alt={`${post.title} — OVARD Digital`} className="blog-card-img" loading="lazy" />
                  <span className="blog-card-category">{post.category}</span>
                </div>
                <div className="blog-card-body">
                  <div className="blog-card-meta">
                    <span>{post.date}</span>
                    <span className="blog-card-meta-sep">·</span>
                    <span>{post.readTime}</span>
                  </div>
                  <h2 className="blog-card-title">{post.title}</h2>
                  <p className="blog-card-excerpt">{post.excerpt}</p>
                  <span className="blog-card-cta">
                    Read article
                    <svg width="14" height="10" viewBox="0 0 14 10" fill="none">
                      <path d="M8 1L13 5L8 9" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M13 5H1" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
                    </svg>
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
